
export const subscription = {
  // Subscription translations
  freePlan: 'Plan Gratuito',
  premiumPlan: 'Plan Premium',
  subscription: 'Suscripción',
  currentPlan: 'Plan Actual',
  managePlan: 'Gestionar Plan',
  upgradeToPremium: 'Mejorar a Premium',
  subscriptionPrice: 'Precio de suscripción',
  month: 'mes',
  free: 'Gratis',
  nextBillingDate: 'Próxima fecha de cobro',
  status: 'Estado',
  active: 'Activo',
  inactive: 'Inactivo',
  cancelling: 'Cancelando',
  cancelSubscription: 'Cancelar suscripción',
  cancelSubscriptionConfirmation: '¿Estás seguro que deseas cancelar tu suscripción?',
  cancelSubscriptionWarning: 'Tu suscripción seguirá activa hasta el final del período actual, pero no se renovará automáticamente.',
  confirmCancellation: 'Confirmar Cancelación',
  subscriptionCancelled: 'Suscripción Cancelada',
  subscriptionWillEndOn: 'Tu suscripción terminará el {date}',
  cancellationError: 'Error de Cancelación',
  couldNotCancelSubscription: 'No se pudo cancelar la suscripción. Por favor intenta de nuevo.',
  processing: 'Procesando',
  paymentMethods: 'Métodos de pago',
  addPaymentMethod: 'Añadir método de pago',
  noPaymentMethodsYet: 'Aún no has añadido métodos de pago',
  expiresOn: 'expira el',
  edit: 'Editar',
  billingHistory: 'Historial de facturación',
  otherSessionsClosed: 'Otras sesiones cerradas',
  successfullyLoggedOutOtherDevices: 'Se ha cerrado sesión exitosamente en otros dispositivos',
  logoutError: 'Error de cierre de sesión',
  couldNotLogoutOtherSessions: 'No se pudieron cerrar las otras sesiones',
  loggingOut: 'Cerrando sesión',
  logoutOtherSessionsConfirm: 'Cerrar otras sesiones',
  tryAgainLater: 'Por favor intenta de nuevo más tarde.',
  // New PayPal related translations
  subscribeWithCard: 'Suscribirse', // Changed from "Suscribirse con Tarjeta"
  subscribeWithPaypal: 'Suscribirse con PayPal',
  payWith: 'Suscribirse con PayPal',
  creatingSubscription: 'Creando suscripción...',
  loadingPaypal: 'Cargando PayPal...',
  subscriptionSuccessful: 'Suscripción Exitosa',
  subscriptionSuccessMessage: '¡Te has suscrito con éxito a {plan}!',
  paypalError: 'Error de PayPal',
  paypalErrorMessage: 'Hubo un error procesando tu suscripción. Por favor, intenta de nuevo.',
  upgrade: 'Mejorar',
  downgrade: 'Reducir',
  subscribe: 'Suscribirse',
  unsubscribe: 'Cancelar suscripción',
  subscriptionFeatures: 'Características',
  billingInfo: 'Información de facturación',
  updatePaymentMethod: 'Actualizar método de pago',
  subscriptionHistory: 'Historial',
  subscriptionPlans: 'Planes',
  premiumFeature: 'Función Premium',
  upgradeToUsePremiumFeature: 'Mejora a Premium para usar esta función y desbloquear todas las herramientas avanzadas.',
  proPlan: 'Plan Pro',
  businessPlan: 'Plan Empresarial',
};
